import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><path style={{
    fill: "#73AF00"
  }} d="M0,385.379c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345  v-76.414H0V385.379z" /><path style={{
    fill: "#FF4B55"
  }} d="M473.655,88.276H38.345C17.167,88.276,0,105.443,0,126.621v76.414h512v-76.414  C512,105.443,494.833,88.276,473.655,88.276z" /><rect y={220.69} style={{
    fill: "#41479B"
  }} width={512} height={70.62} /><g><rect y={203.03} style={{
      fill: "#F5F5F5"
    }} width={512} height={17.655} /><rect y={291.31} style={{
      fill: "#F5F5F5"
    }} width={512} height={17.655} /></g><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };